import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
// import { AnimatePresence, motion } from "framer-motion";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./Sidebar";
import {
  faArrowRightFromBracket,
  faBars,
  faBarsProgress,
  faBuildingColumns,
  faChartSimple,
  faGraduationCap,
  faList,
  faPaperPlane,
  faTicket,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FaBookReader, FaFilePrescription, FaHome } from "react-icons/fa";
import { BiDonateHeart } from "react-icons/bi";
import { CiText } from "react-icons/ci";
import { AiFillContacts } from "react-icons/ai";
import { FaRegCalendarAlt } from "react-icons/fa";
import { CiHome } from "react-icons/ci";
import { MdEventAvailable } from "react-icons/md";
import { FaChessBoard } from "react-icons/fa6";
import { FaTools } from "react-icons/fa";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { FaRegCircleQuestion } from "react-icons/fa6";
import { MdOutlineAccountTree } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import { GrNotes } from "react-icons/gr";
import { PiUserSwitch } from "react-icons/pi";

// importing styling for the sidebar
import "./style.css";
import { icons } from "antd/es/image/PreviewGroup";

// declaring admin routes
const Routes = [
  {
    path: "/dashboard/home",
    name: "Home",
    icon: <FaHome />,
  },
  {
    path: "/dashboard/event",
    name: "Events",
    icon: <MdEventAvailable />,
  },
  {
    path: "/dashboard/chat",
    name: "Chat",
    icon: <IoChatboxEllipsesOutline />,
  },
  {
    path: "/dashboard/challenges",
    name: "Challenges",
    icon: <FaRegCircleQuestion />,
  },
  {
    path: "/dashboard/accountibility",
    name: "Accountability",
    icon: <MdOutlineAccountTree />,
  },
  {
    path: "/dashboard/member-leaderboard",
    name: "Leaderboard",
    icon: <FaChessBoard />,
  },
  {
    path: "/dashboard/marketing",
    name: "Marketing Tools",
    icon: <FaBookReader />,
  },
  {
    path: "/dashboard/crowdsourced",
    name: "Crowdsourced Marketing",
    icon: <FaTools />,
  },
  {
    path: "/dashboard/magazines",
    name: "Magazines",
    icon: <GrNotes />,
  },
  {
    path: "/",
    name: "Logout",
    icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
  },
];

const hostRoutes = [
  {
    path: "/dashboard/event",
    name: "Events",
    icon: <MdEventAvailable />,
  },
  {
    path: "/dashboard/challenges",
    name: "Challenges",
    icon: <FaRegCircleQuestion />,
  },
  {
    path: "/dashboard/marketing",
    name: "Marketing Tools",
    icon: <FaBookReader />,
  },
  {
    path: "/dashboard/crowdsourced",
    name: "Crowdsourced Marketing",
    icon: <FaTools />,
  },
  {
    path: "/dashboard/chat",
    name: "Chat",
    icon: <IoChatboxEllipsesOutline />,
  },
  {
    path: "/dashboard/host-leaderboard",
    name: "Leaderboard",
    icon: <FaChessBoard />,
  },
  {
    path: "/dashboard/member-leaderboard",
    name: "Member Leaderboard",
    icon: <FaChessBoard />,
  },
  {
    path: "/dashboard/my-members",
    name: "My Members",
    icon: <FaRegUser />,
  },
  {
    path: "/dashboard/magazines",
    name: "Magazines",
    icon: <GrNotes />,
  },
  {
    path: "/",
    name: "Logout",
    icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
  },
];

const adminRoutes = [
  {
    path: "/dashboard/event",
    name: "Events",
    icon: <MdEventAvailable />,
  },
  {
    path: "/dashboard/challenges",
    name: "Challenges",
    icon: <FaRegCircleQuestion />,
  },
  {
    path: "/dashboard/crowdsourced",
    name: "Crowdsourced Marketing",
    icon: <FaTools />,
  },
  {
    path: "/dashboard/member-leaderboard",
    name: "Member Leaderboard",
    icon: <FaChessBoard />,
  },
  {
    path: "/dashboard/host-leaderboard",
    name: "Host Leaderboard",
    icon: <FaChessBoard />,
  },
  {
    path: "/dashboard/users",
    name: "Users",
    icon: <FaRegUser />,
  },
  {
    path: "/dashboard/notifications",
    name: "Notifications",
    icon: <GrAnnounce />,
  },
  {
    path: "/dashboard/magazines",
    name: "Magazines",
    icon: <GrNotes />,
  },
  {
    path: "/dashboard/applications",
    name: "Applications",
    icon: <PiUserSwitch />,
  },
  {
    path: "/dashboard/contact",
    name: "Contacts",
    icon: <AiFillContacts />,
  },
  {
    path: "/dashboard/admins",
    name: "Admins",
    icon: <AiFillContacts />,
  },
  {
    path: "/",
    name: "Logout",
    icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
  },
];

const SideBar = ({ children }) => {
  // declaring states to manage the component
  const [isOpen, setIsOpen] = useState(true);
  const [user, setUser] = useState(null);
  const [finalRoutes, setFinalRoutes] = useState(null);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };
  // closing and opening the SideBar
  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };
  // this function will first time when this component will render
  useEffect(() => {
    // geting user from the localStorage and seting to the state
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUser(user);
      if (user?.role == "admin") {
        setFinalRoutes(adminRoutes);
      } else if (user?.role == "member") {
        setFinalRoutes(Routes);
      } else {
        setFinalRoutes(hostRoutes);
      }
    }
  }, []);
  return (
    <div className="main-container">
      <motion.div
        animate={{
          width: isOpen ? "270px" : "45px",
          transition: {
            duration: 0.3,
            type: "spring",
            damping: 10,
          },
        }}
        className="sidebar_college"
      >
        <section className="routes">
          {finalRoutes?.map((route, index) => {
            if (route.subRoutes) {
              return (
                <SidebarMenu
                  setIsOpen={setIsOpen}
                  route={route}
                  showAnimation={showAnimation}
                  isOpen={isOpen}
                />
              );
            }

            return (
              <NavLink
                to={route.path}
                key={index}
                className="link"
                activeClassName="active"
                onClick={() => {
                  if (route.name == "Logout") {
                    localStorage.removeItem("user");
                    window.location.reload();
                  }
                }}
              >
                <div style={{ fontSize: "22px" }}>{route.icon}</div>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      variants={showAnimation}
                      initial="hidden"
                      animate="show"
                      exit="hidden"
                      className="link_text"
                    >
                      {route.name}
                    </motion.div>
                  )}
                </AnimatePresence>
              </NavLink>
            );
          })}
        </section>
      </motion.div>
      <main style={{ margin: "7px", width: `100%` }}>{children}</main>
    </div>
  );
};

export default SideBar;
